<template>
    <SessionVisualization v-if="sessionData !== null"
                          :initialData="sessionData"
                          :loadSessionData="loadSessionData"
                          @ready="hideLoader" />
    <section v-else>
        <VisualizationHeader :session="{}" />
    </section>
</template>

<script charset="utf-8">
    import SessionVisualization from "@/components/Visualization/SessionVisualization.vue";
    import VisualizationHeader from "@/components/Visualization/VisualizationHeader.vue";
    import PublicService from "../services/public.service";
    import esesjaInteractivePublicService from "../services/esesja.interactive.public.service";
    import AlertHelper from '@/helpers/alerts.helper.js';
    import { loadOwLanguage } from "@/helpers/ow.language.helper";

    /**
     * Okno wizualizacji konkretnego posiedzenia (/PublicSession/:code). Odpowiada za kod z adresu,
     * pobranie posiedzenia i dotychczasową obsługę błędów. Prezentację i SignalR prowadzi
     * SessionVisualization - wspólna z oknem pod stałym linkiem jednostki (/Visualization/:code).
     */
    export default {
        name: "PublicSession",
        components: {
            SessionVisualization,
            VisualizationHeader
        },
        data() {
            return {
                code: '',
                sessionData: null,
            };
        },
        computed: {
            getLangCode(){
                return this.$route.query.lang;
            }
        },
        async created(){
            try{
                this.$i18n.locale = await loadOwLanguage(this.getLangCode);
            }
            catch(e){
                console.log(e);
            }
        },
        async mounted() {
            this.$store.commit("showLoader");
            this.code = this.$route.params.code;

            if (this.code != undefined && this.code != null && this.code.length == 79) {
                try {
                    // loader znika dopiero po wejściu do grupy SignalR - zdarzenie ready prezentacji
                    this.sessionData = await this.loadSessionData();
                }
                catch (err) {
                    this.sessionData = null;
                    if (err.response !== undefined && err.response.status == 404) {
                        this.$swal(AlertHelper.errorAlert(this.$t('com.validate-error.no-session-or-hide'), this.$t('com.global.error')));
                    }
                    else {
                        this.$swal(AlertHelper.errorAlert(this.$t('com.validate-error.unauthorize-error-check-info'), this.$t('com.global.error')));
                    }
                    this.hideLoader();
                }
            }
            else {
                this.sessionData = null;
                this.$swal(AlertHelper.errorAlert(this.$t('com.validate-error.invalid-identification'), this.$t('com.global.error')));
                this.hideLoader();
            }
        },
        unmounted() {
            this.endInteractiveSession();
        },
        methods: {
            async loadSessionData() {
                const response = await PublicService.getPublicSession(this.code, this.$i18n.locale);
                return response.data;
            },
            hideLoader() {
                this.$store.commit("hideLoader");
            },
            async endInteractiveSession() {
                try {
                    await esesjaInteractivePublicService.stop();
                }
                catch {
                    var t = this.$swal.mixin(AlertHelper.errorToastElement());
                    t.fire(AlertHelper.errorToastAlert(this.$t('com.validate-error.close-connection-error'), this.$t('com.global.error')));
                }
            }
        }
    };
</script>
